module.exports = __webpack_public_path__ + "static/img/eclipse.bd947bc.gif";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/eclipse.gif
// module id = Pa+M
// module chunks = 1